<app-page-bar></app-page-bar>

<app-page>

  <h2>Leads</h2>

  <mat-card>

    <app-list-filter-group>
      <app-text-list-filter [list]="leadInformations"></app-text-list-filter>
    </app-list-filter-group>

    <mat-table [dataSource]="leadInformations" matSort (matSortChange)="leadInformations.setSort($event.active, $event.direction)"
               matSortDisableClear="true" [matSortActive]="leadInformations.state.sort.key"
               [matSortDirection]="leadInformations.state.sort.direction">

      <ng-container matColumnDef="companyBusinessId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>BusinessId</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.companyBusinessId}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="companyName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Company</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.companyName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>First Name</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.firstName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.lastName}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="phone">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Phone</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.phone}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.email}}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Created</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.created | date:'medium'}}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columns;"></mat-row>

    </mat-table>

    <mat-paginator *ngIf="(leadInformations.loadingObservable | async) !== true"
                   [length]="leadInformations.total"
                   [pageIndex]="leadInformations.state.pager.page - 1"
                   [pageSize]="leadInformations.state.pager.size"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   showFirstLastButtons="true"
                   (page)="leadInformations.setPage($event.pageIndex + 1, $event.pageSize)">
    </mat-paginator>

    <app-list-loader [list]="leadInformations"></app-list-loader>

  </mat-card>

</app-page>
